import React from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../icon';

const IconOrImage = ({ icon }) => {
  const { Size200, full, alt } = icon?.[0] || {};
  if (!Size200 && !full) return null;

  return (
    <div className="solutions-card__link--icon">
      {Size200 ? (
        <img loading="lazy" src={Size200} alt={alt} />
      ) : (
        <Icon iconField={{ iconUrl: full, iconAlt: alt }} color="primary" size={iconSize['xxlg']} />
      )}
    </div>
  );
};

export default IconOrImage;
